import React from "react";
import { Radio } from "antd";
import { useHistory } from "react-router-dom";
import Stepper from "./Stepper";

function TabMenu(props) {
  let history = useHistory();

  const handleMenuChange = (e) => {
    history.push(`/documents/${props.id}/${e.target.value}`);
  };

  return (
    <div>
      <Stepper status={props.statusOf} />
      <Radio.Group
        value={props.menu}
        onChange={handleMenuChange}
        style={{ marginBottom: 10 }}
      >
        <Radio.Button value="summary" style={{ marginRight: 5 }}>
          Summary
        </Radio.Button>

        {/* <Radio.Button value="history" style={{ marginRight: 5 }}>
          History
        </Radio.Button> */}

        <Radio.Button value="sub-documents" style={{ marginRight: 5 }}>
          Documents
        </Radio.Button>

        {/* <Radio.Button value="transactions" style={{ marginRight: 5 }}>
          Transactions
        </Radio.Button> */}
        {/* <Radio.Button value="upload" style={{ marginRight: 5 }}>
          Upload BOM
        </Radio.Button> */}
      </Radio.Group>
    </div>
  );
}

export default TabMenu;
